import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'res-menu',
  templateUrl: './res-menu.component.html',
  styleUrls: ['./res-menu.component.css']
})
export class ResMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
